import { Component } from '@angular/core';

@Component({
  templateUrl: 'expire.component.html'
})
export class ExpireComponent {

  constructor() { }

}
